import React from 'react';
import _capitalize from 'lodash/capitalize';

import { StatusText as StatusWrapper } from '@medipass/react-core';
const QUOTE_STATUS_ICON = {
  requested: 'fas fa-check',
};
const QUOTE_STATUS_TEXT_CLASSES = {
  requested: 'primary',
};
type Props = {
  status: string;
};

const QuoteStatus = ({ status }: Props) => (
  <StatusWrapper
    description={_capitalize(status)}
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    statusTextClass={QUOTE_STATUS_TEXT_CLASSES[status]}
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    statusIcon={QUOTE_STATUS_ICON[status]}
  />
);

export default QuoteStatus;
